<ng-container *ngIf="facade.selectedUser$ | async as user; else loadingUser">
  <div class="main-container" *ngIf="facade.userLoadedForEdit$ | async">
    <div class="title">
      <h1>
        {{ 'title.edit_user' | translate | uppercase }}
        {{ user.username | uppercase }}
      </h1>
    </div>

    <!-- Title -->
    <div class="card">
      <div class="card-body align-center">
        <img
          [src]="user.avatarUrl"
          *ngIf="user.avatarUrl"
          alt="user avatar"
          class="user-avatar user-avatar--100"
          width
        />
      </div>
      <div class="card-body">
        <ts-role-switchers
          [options]="roles$ | async"
          [loading]="loadingRoles$ | async"
          [enabled]="facade.selectedUserRoles$ | async"
          (granted)="facade.grantRole($event)"
          (revoked)="facade.revokeRole($event)"
        ></ts-role-switchers>
        <div *ngIf="facade.isDemoted$ | async" class="text-warning" data-cy="role-revoke-warning">
          {{ 'warning.user_role_revoking' | translate }}
        </div>
      </div>
      <div class="card-body">
        <div id="workspaces-label" class="text-uppercase">
          {{ 'title.workspaces' | translate }} ({{ 'core.optional' | translate }})
        </div>

        <ng-container *ngIf="facade.loadingMemberships$ | async; else workspaceSelector">
          <div class="spinner-container">
            <mat-spinner [diameter]="24"></mat-spinner>
          </div>
        </ng-container>

        <ng-template #workspaceSelector>
          <ts-workspace-selector
            *ngIf="{
              options: facade.workspaces$ | async,
              selected: facade.selectedWorkspaces$ | async,
              totalSelected: facade.selectedWorkspacesCount$ | async,
              total: facade.totalWorkspaces$ | async,
              loaded: (facade.hasMoreWorkspaces$ | async) === false,
              hasMore: facade.hasMoreWorkspaces$ | async
            } as state"
            [options]="state.options"
            [selected]="state.selected"
            [totalSelected]="state.totalSelected"
            [totalAvailable]="state.total"
            (added)="addToWorkspaces($event)"
            (removed)="removeFromWorkspaces($event)"
            [loaded]="state.loaded"
            (lastItemReached)="loadMoreWorkspaces(state.hasMore)"
            (selectAllAcrossPages)="loadAllWorkspaces()"
            [searchTerm]="initialWorkspaceSearchTerm"
            (searchTermChanged)="searchWorkspace($event)"
          ></ts-workspace-selector>
        </ng-template>
      </div>
      <div class="card-footer card-actions no-hr">
        <button
          type="button"
          class="btn btn-outline-primary card-actions__action"
          (click)="navigateToUsers()"
          data-cy="button-cancel-user"
        >
          <i class="ri-close-fill"></i>
          {{ 'button.cancel' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary card-actions__action"
          [disabled]="(facade.hasChanges$ | async) === false || (facade.loadingMemberships$ | async) === true"
          (click)="update()"
          data-cy="button-save-user"
        >
          <i class="ri-save-line"></i>
          {{ 'button.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingUser>
  <div class="spinner-container">
    <mat-spinner [diameter]="48"></mat-spinner>
  </div>
</ng-template>
